export const DELIMITER = '*';
export const NULL = 'null';
